import {
    BANK_ACCOUNTS_GET,
    BANK_ACCOUNT_CREATE,
    BANK_ACCOUNT_DELETE,
    BANK_ACCOUNT_DEFAULT,
    FINANCE_GET,
    FINANCE_CREATE,
    FINANCE_GET_ID,
    FINANCE_SEARCH,
    PAYMENT_SEARCH,
    RECEIPT_ACCOUNTS_GET,
    RECEIPT_ACCOUNT_CREATE,
    MOVEMENT_ACCOUNTS_GET,
    MOVEMENT_ACCOUNT_CREATE,
    ACCOUNTS_LIST_GET,
    MOVEMENT_ACCOUNTS_BANKS_GET,
    MOVEMENT_ACCOUNT_DELETE,
    RECEIPT_ACCOUNT_DELETE
} from './actions/financial.type.js'
import {
    SET_FINANCE,
    SET_BANK_ACCOUNTS,
    SET_BANK_ACCOUNT,
    FINANCIAL_RESET_STATE,
    SET_BANK_ACCOUNTS_DEFAULT,
    REMOVE_BANK_ACCOUNT,
    SET_FINANCIAL,
    FINANCIAL_ID_RESET_STATE,
    SET_FINANCES,
    SET_FINANCE_PAGINATION,
    SET_PAYMENT_PAGINATION,
    SET_PAYMENTS,
    SET_RECEIPT_ACCOUNTS,
    SET_MOVEMENTS_ACCOUNTS,
    SET_LIST_ACCOUNTS

} from './mutations/financial.type.js'

import {CHANGE_PROGRESS} from './mutations/mutations.type.js'
import {FinancialService} from "@/common/api/financial.service";


const initialState = () => {
    return {

        accountCategory: [
            {"id": 1, "name": "Movimento - Conta Corrente"},
            {"id": 2, "name": "Movimento - Conta Poupança"},
            {"id": 3, "name": "Movimento - Caixinha"},
            {"id": 4, "name": "Recebimento - Cartão de Débito"},
            {"id": 5, "name": "Recebimento - Cartão de Crédito"},
        ],

        movementAccount: {
            id: 0,
            bsAccountCategory: 0,
            name: "",
            bank: "",
            agency: "",
            bankAccount: "",
            initialBalance: "",
            balanceDate: "",
            chavePIXType: "",
            chavePIX: "",
            deleted: false,
            active: false
        },

        receiptAccount: {
            id: 0,
            bsAccountCategory: 0,
            name: "",
            bsAccountMovementID: null,
            fee: 0.0,
            cardMachine: "",
            valueMachine: null,
            dayMachine: null,
            installmentMachine: null,
            installmentFee: null,
            cardCycle: null,
            rescueDay: null,
            closingDay: null,
            receiptDay: null,
            installment: false,
            installmentMax: null,
            installmentFeeBy: null,
            freeFee: false,
            installmentsFreeFee: null,
            deleted: false,
            active: false
        },

        movementAccounts: [],
        receiptAccounts: [],
        listAccounts: [],

        bankAccount: {
            bank: "",
            agency: "",
            account: "",
            chavePIX: ""
        },


        financial: {
            id: 0,
            typeAccount: 0,
            bank: "",
            agency: "",
            bankAccount: "",
            chavePIX: "",
            valueReleased: 0,
            valueAnticipation: 0,
            rateAnticipation: 0,
            totalValue: 0,
            requestDate: null,
            payDate: null,
            requested: false,
            paid: null,
            balanceDay: 0
        },

        financePagination: {
            search: "",
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
        },
        finances: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            items: []
        },

        paymentPagination: {
            search: "",
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
        },
        payments: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            items: []
        },

        finance: {
            balanceDay: "",
            balanceReleased: "",
            balanceToReleased: "",
            balanceTotal: "",
            rateAnticipation: null
        },
        edit: false,
        bankAccounts: [],

    }
}

export const state = initialState()

const getters = {
    movementAccount: state => {
        return state.movementAccount
    },
    receiptAccount: state => {
        return state.receiptAccount
    },
    bankAccount: state => {
        return state.bankAccount
    },
    bankAccounts: state => {
        return state.bankAccounts
    },
    movementAccounts: state => {
        return state.movementAccounts
    },
    receiptAccounts: state => {
        return state.receiptAccounts
    },
    listAccounts: state => {
        return state.listAccounts
    },
    finance: state => {
        return state.finance
    },
    finances: state => {
        return state.finances
    },
    financePagination: state => {
        return state.financePagination
    },
    financial: state => {
        return state.financial
    },
    payments: state => {
        return state.payments
    },
    paymentPagination: state => {
        return state.paymentPagination
    },
    accountCategory: state => {
        return state.accountCategory
    }
}

export const mutations = {
    [SET_BANK_ACCOUNT](state, data) {
        state.bankAcount = data
    },

    [SET_FINANCE](state, data) {
        state.finance = data
    },
    [SET_FINANCES](state, data) {
        state.finances = data
    },
    [SET_PAYMENTS](state, data) {
        state.payments = data
    },
    [SET_FINANCIAL](state, data) {
        state.financial = data
    },
    [SET_BANK_ACCOUNTS](state, data) {
        state.bankAccounts = data
    },
    [SET_RECEIPT_ACCOUNTS](state, data) {
        state.receiptAccounts = data
    },
    [SET_MOVEMENTS_ACCOUNTS](state, data) {
        state.movementAccounts = data
    },
    [SET_LIST_ACCOUNTS](state, data) {
        state.listAccounts = data //[...state.receiptAccounts, ...state.movementAccounts].sort((a, b) => a.name.localeCompare(b.name))
    },
    
    [SET_FINANCE_PAGINATION](state, data) {
        state.finances.activePage = data.page
        state.financePagination.itemsPerPage = data.itemsPerPage
        state.financePagination.orderBy = data.orderBy
        state.financePagination.sortDesc = data.sortDesc
    },
    [SET_PAYMENT_PAGINATION](state, data) {
        state.payments.activePage = data.page
        state.paymentPagination.itemsPerPage = data.itemsPerPage
        state.paymentPagination.orderBy = data.orderBy
        state.paymentPagination.sortDesc = data.sortDesc
    },

    [SET_BANK_ACCOUNTS_DEFAULT](state, index) {
        for (let i = 0; i < state.bankAccounts.length; i++) {
            state.bankAccounts[i].default = false;
        }
        state.bankAccounts[index].default = true;
    },
    [REMOVE_BANK_ACCOUNT](state, index) {
        state.bankAccounts.splice(index, 1)
    },
    [FINANCIAL_ID_RESET_STATE](state) {
        Object.assign(state.financial, initialState().financial)
    },
    [FINANCIAL_RESET_STATE](state) {
        Object.assign(state, initialState())
    },
}

export const actions = {
    async [BANK_ACCOUNTS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await FinancialService.list()
        commit(SET_BANK_ACCOUNTS, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [FINANCE_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await FinancialService.get()
        commit(SET_FINANCE, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [FINANCE_GET_ID]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await FinancialService.getID(id)
        commit(SET_FINANCIAL, data)
        commit(CHANGE_PROGRESS, false)
    },
    
    [FINANCE_CREATE](_, data) {
        return FinancialService.post(data)
    },
    async [FINANCE_SEARCH]({commit, state}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await FinancialService.search(
            state.finances.activePage,
            state.financePagination.itemsPerPage,
            state.finances.active,
            state.financePagination.search,
            state.financePagination.orderBy,
            state.financePagination.sortDesc)
        commit(SET_FINANCES, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [PAYMENT_SEARCH]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await FinancialService.searchPayments(
            state.payments.activePage,
            state.paymentPagination.itemsPerPage,
            state.payments.active,
            state.paymentPagination.search,
            state.paymentPagination.orderBy,
            state.paymentPagination.sortDesc)
        commit(SET_PAYMENTS, data)
        commit(CHANGE_PROGRESS, false)
    },

    [BANK_ACCOUNT_CREATE](_, data) {
        return FinancialService.createBank(data)
    },
    [BANK_ACCOUNT_DEFAULT](_, id) {
        return FinancialService.setDefaultBank(id)
    },
    [BANK_ACCOUNT_DELETE](_, id) {
        return FinancialService.deleteBank(id)
    },
    [MOVEMENT_ACCOUNT_DELETE](_, movementID) {

        return FinancialService.deleteMovementAccount(movementID)
    },
    [MOVEMENT_ACCOUNT_CREATE](_, data) {
        return FinancialService.addMovement(data)
    },
    async [MOVEMENT_ACCOUNTS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await FinancialService.listMovement()
        commit(SET_MOVEMENTS_ACCOUNTS, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [MOVEMENT_ACCOUNTS_BANKS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await FinancialService.listMovementBanks()
        commit(SET_MOVEMENTS_ACCOUNTS, data)
        commit(CHANGE_PROGRESS, false)
    },

    [RECEIPT_ACCOUNT_CREATE]({state}, data) {
        data.bsAccountCategory = state.movementAccount.bsAccountCategory
        return FinancialService.addReceipt(data)
    },
    
    [RECEIPT_ACCOUNT_DELETE](_, receiptID) {

        return FinancialService.deleteReceiptAccount(receiptID)
    },
    async [RECEIPT_ACCOUNTS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await FinancialService.listReceipt()
        commit(SET_RECEIPT_ACCOUNTS, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [ACCOUNTS_LIST_GET]({commit}) {

        commit(CHANGE_PROGRESS, true)
        // await dispatch(MOVEMENT_ACCOUNTS_GET)
        // await dispatch(RECEIPT_ACCOUNTS_GET)

        const {data} = await FinancialService.listAccounts()
        
        commit(SET_LIST_ACCOUNTS, data)
        commit(CHANGE_PROGRESS, false)
    },


}
export default {
    state,
    actions,
    mutations,
    getters
}
